import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {ExpenseCategoryStatus} from "../../types/expenses-category-status.type";
import {ExpensesCategoriesDialogService} from "../../services/expenses-categories-dialog.service";
import {ExpensesCategoriesService} from "../../services/expenses-categories-service.service";
import {PreferencesDialogService} from "../../../site-preferences/services/preferences-dialogs-service.service";
import {CommonsAlertsService} from "../../../commons/services/commons-alerts.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";

export class ExpensesConfigurationComponent implements IController {

  preferences: any;

  public expensesCategoriesRef: any;
  public loadLimit: number;
  public infiniteScroll: any;
  public selectedTab: number;
  public filtersConfig: any;

  constructor(private $log, private $expensesCategories, private $infiniteScroll,
              private expensesCategoriesService: ExpensesCategoriesService, private expensesCategoriesDialogService: ExpensesCategoriesDialogService,
              private confirmDialogService: ConfirmDialogService, private preferencesDialogService: PreferencesDialogService, private commonsAlertsService: CommonsAlertsService) {
  }

  $onInit() {
    this.expensesCategoriesRef = this.$expensesCategories();
    this.loadLimit = 20;

    this.filtersConfig = {
      queryString: undefined,
      bringozFilters: {
        statuses: ExpenseCategoryStatus.ACTIVE
      }
    }

    this.expensesCategoriesRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.expensesCategoriesRef, this.loadLimit, {getFullData: true});
  }

  onTabSelect(selectedTab) {
    this.selectedTab = selectedTab;
  }

  onAddCategory(event) {
    this.expensesCategoriesDialogService.createCategory(event)
      .then((category) => {
        this._onCreateCategory(category);
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  onEditCategory(category, $event) {
    const categoryCopy = angular.copy(category);
    this.expensesCategoriesDialogService.editCategory(categoryCopy, $event)
      .then((category) => {
        this._onEditCategory(category);
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  onArchive(categoryId) {
    this.confirmDialogService.confirm('Archive Category', 'Are you sure you want to archive category?', event)
      .then(() => {
        this._onArchiveCategory(categoryId)
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onEditPreference(event, property, index) {
    this.preferencesDialogService.editPreferencesProperty(event, property)
      .then((updated) => {
        const updatedValue = updated[0];
        const group = _.camelCase(updatedValue.group);

        this.preferences[group].list[index] = updatedValue;
        this.commonsAlertsService.preferencesByNameSuccess('preferences.' + property.key + '.name');
      })
      .catch((error) => {
        if (error) {
          this.commonsAlertsService.preferencesError();
        }
      })
  }

  submitQuery(queryString) {
    this.filtersConfig.queryString = queryString;
    this.reload();
  }


  onExpensesCategoryStatusesChanged(selectedId) {
    _.set(this.filtersConfig, 'bringozFilters.statuses', selectedId);
    this.reload();
  }

  private reload() {
    this.expensesCategoriesRef.$query(this._getQueryPayload()).then(() => {
      this.infiniteScroll.reload();
    }, () => {
      this.$log.debug('Fail to $query');
    });
  }

  private _getQueryPayload() {
    return {
      limit: this.loadLimit,
      query: this.filtersConfig.queryString,
      active: this.filtersConfig.bringozFilters.statuses === ExpenseCategoryStatus.ACTIVE ? true : (this.filtersConfig.bringozFilters.statuses === ExpenseCategoryStatus.ARCHIVED ? false : undefined),
    };
  }

  private _onCreateCategory(category) {
    this.expensesCategoriesService.createCategory(category)
      .then((category) => {
        this.infiniteScroll.addItems([category]);
      });
  }

  private _onEditCategory(category) {
    this.expensesCategoriesService.updateCategory(category)
      .then(() => {
        // this.infiniteScroll.removeItems([category]);
        // this.infiniteScroll.addItems([category]);
        this.reload();
      });
  }

  private _onArchiveCategory(categoryId) {
    this.expensesCategoriesService.archiveCategory(categoryId)
      .then((category) => {
        // this.infiniteScroll.removeItems([category]);
        // this.infiniteScroll.addItems([category]);
        this.reload();
      });
  }
}

angular
  .module('bringoz.admin.expenses')
  .component('expensesConfiguration', {
    bindings: {
      preferences: '<'
    },
    template: require('./expenses-configuration.html').default,
    controller: ExpensesConfigurationComponent
  });

